import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

export const estimatedCostColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
  className = 'max-w-[20vw] w-[20vw]',
): TableColumn<T> => ({
  id: 'estimatedCost',
  label: <Trans i18nKey="estimated_cost" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{value.toFixed(2)} €</div>
  ),
  acessorKey: 'estimatedCost',
  sortable: true,
  className,
  ...options,
});
